import { Component, Inject, OnInit } from '@angular/core';
import { DmsCallService } from '../services/dms-call.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  companyName: any
  homePageContent:any
  homePageStyle!: SafeHtml;
  constructor(
    private commonService: CommonService,
    private dmsCallService: DmsCallService,    private sanitizer: DomSanitizer 
  ) { }

  async ngOnInit() {
    // let  data = this.dmsCallService.getCountry()
    // console.log(data)
    var subject = "One times two plus one equals three.";

    // Solution 1:

    var regex = /\b(?:one|two|three)\b/gi;

    subject.match(regex);
    // Returns an array with four matches: ["One","two","one","three"]

    this.getSubdomain()
    console.log("Hostname:", this.companyName);
    this.getHomeData()
  }
  getSubdomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    // Special case: localhost
    if (hostname === "localhost") {
      this.companyName = "kanbiosys";
      return this.companyName;
    }

    // If there are more than 2 parts, first part is subdomain
    if (parts.length > 2) {
      this.companyName = parts[0];
      return this.companyName;
    }

    // No subdomain
    this.companyName = null;
    return this.companyName;
  }
getHomeData() {
  const param = {};
  const head = { BPCode: "", CompanyID: "", auth_Control: "", companyName: this.companyName };
  const dataObj = { param, head };

  this.dmsCallService.getHomeData(dataObj).subscribe({
    next: (result: any) => {
      this.homePageContent = result.homePageContent;

      // Inject style safely
      this.homePageStyle = this.sanitizer.bypassSecurityTrustHtml(
        `<style>${result.homePageStyle}</style>`
      );
    },
    error: (error: any) => {
      this.commonService.showError(error);
    }
  });
}




}
